module.exports = __webpack_public_path__ + "static/img/ban.f63fc1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductsCenter/img/ban.jpg
// module id = VuSc
// module chunks = 1